<template>
    <div class="form-edit-modal-wrapper">
        <FullHeightBaseBox class="form-edit-box" :class="{ 'form-edit-tranform': compeleted }" :title="boxTitle" @close="close">
            <div class="form-edit-content">
                <div class="edit-center">
                    <LeftEditForm class="left-panel"></LeftEditForm>
                    <FormPanel class="right-panel" :isShowDefault="isShowDefault" />
                </div>
            </div>
            <BottomOptBar class="edit-bottom" @cancelClick="close" @continueClick="continueClick"></BottomOptBar>
        </FullHeightBaseBox>
    </div>
</template>

<script>
import FullHeightBaseBox from "@/views/zhiji/bComponents/FullHeightBaseBox";
import LeftEditForm from "./LeftEditForm";
import FormPanel from "./FormPanel";
import BottomOptBar from "./BottomOptBar";

export default {
    name: "FormEditModal",
    props: [],
    components: {
        FullHeightBaseBox,
        LeftEditForm,
        FormPanel,
        BottomOptBar
    },
    data() {
        return {
            compeleted: false,
            showingPanel: "",
            isShowDefault: false
        };
    },
    computed: {
        boxTitle() {
            return this.$t("zhiji.form.formEdit");
        }
    },
    methods: {
        close() {
            this.compeleted = false;
            setTimeout(() => {
                this.$emit("closeModal");
            }, 500);
            this.$store.commit("zhiji/editFormsClearModule");
            this.$store.dispatch("zhiji/queryFormList");
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.formManagePage[propName];
        },
        continueClick(data) {
            this.isShowDefault = data.isContinueAdd;
        }
    },
    mounted() {
        setTimeout(() => {
            this.compeleted = true;
        }, 10);
    }
};
</script>

<style lang="scss" scoped>
.form-edit-modal-wrapper {
    height: 100%;
    width: 100%;
    background: rgba(65, 71, 94, 0.6);
    overflow: hidden;

    .form-edit-box {
        position: absolute;
        top: 0;
        right: 0;
        transition: transform 0.5s;
        transform: translateX(100%);
        width: 970px;
        background: #f2f7fb;
    }

    .form-edit-tranform {
        transform: translateX(0);
    }

    .form-edit-content {
        height: calc(100% - 66px);
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }

    .edit-center {
        flex: 1;
        display: flex;
        height: 100%;
        min-height: 100px;
        .right-panel {
            flex: 1;
            background: #fff;
            overflow: auto;
        }
    }
}
</style>
